var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8753 3.75C9.31321 3.75822 6.92428 3.87022 5.39757 5.39692C3.75 7.04449 3.75 9.69622 3.75 14.9997C3.75 20.3031 3.75 22.9549 5.39757 24.6024C7.04514 26.25 9.69687 26.25 15.0003 26.25C20.3038 26.25 22.9555 26.25 24.6031 24.6024C26.1298 23.0757 26.2418 20.6868 26.25 16.1247",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2493 7.53161L25 7.52845C20.3293 7.51664 17.9939 7.51073 16.3521 8.69082C15.8066 9.08298 15.3278 9.56056 14.9342 10.1052C13.75 11.7439 13.75 14.0793 13.75 18.75M26.2493 7.53161C26.2578 7.32833 26.1851 7.12382 26.0314 6.94167C25.0749 5.80858 22.5889 3.75 22.5889 3.75M26.2493 7.53161C26.2418 7.7139 26.1691 7.8952 26.0311 8.05852C25.0745 9.19138 22.5889 11.25 22.5889 11.25",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.cb4cc32c94b9b58de4dbee510d861ab1.svg";
export { ForwardRef as ReactComponent };